import { render, staticRenderFns } from "./afterSale_list.vue?vue&type=template&id=af3eebea&scoped=true&"
import script from "./afterSale_list.vue?vue&type=script&lang=ts&"
export * from "./afterSale_list.vue?vue&type=script&lang=ts&"
import style0 from "./afterSale_list.vue?vue&type=style&index=0&id=af3eebea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3eebea",
  null
  
)

export default component.exports